var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.9 64.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.9,4.3c0-1-.4-2-1.1-2.7s-1.7-1.2-2.7-1.1c-1,0-2,.4-2.7,1.1l-26.9,27c-.5.5-.9,1.1-1.2,1.8-.3.6-.4,1.3-.4,2s.1,1.4.4,2c.3.6.7,1.3,1.2,1.8l26.9,27c.7.8,1.7,1.2,2.7,1.1,1,0,2-.4,2.7-1.1.7-.8,1.2-1.8,1.1-2.7,0-1-.4-2-1.1-2.7l-25.2-25.3L48.8,7.1c.8-.7,1.2-1.7,1.1-2.8h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e66fc8ec7b8765958ef33d738bbe23f1.svg";
export { ForwardRef as ReactComponent };